import { Translate } from 'react-redux-i18n'
import classes from './index.module.scss'
import PropTypes from 'prop-types'

export const SourceLabel = ({ isRight }) => {
  return (
    <div
      className={classes.source}
      style={{ justifyContent: isRight ? 'flex-end' : 'center' }}
    >
      <Translate value="industryOverview.macroeconomics.SOURCE_GENERAL" />
    </div>
  )
}

SourceLabel.propTypes = {
  isRight: PropTypes.bool,
}

SourceLabel.defaultProps = {
  isRight: false,
}
